// An output's black: a layer over everything in its window, so it wins over the picture and the test card.

/** Covers `doc`'s viewport while `read()` is true, following `store`. */
export const mountBlack = ({ doc, store, read }) => {
	const el = doc.createElement('div')
	Object.assign(el.style, {
		position: 'fixed',
		inset: '0',
		background: '#000',
		zIndex: '2147483647',
		display: 'none',
	})
	el.dataset.outputBlack = ''
	doc.body.append(el)
	let on = null
	const sync = () => {
		const next = !!read(store.getState())
		if (next === on) return
		on = next
		el.style.display = on ? 'block' : 'none'
	}
	sync()
	const off = store.subscribe(sync)
	return () => {
		off()
		el.remove()
	}
}
